module.exports = __webpack_public_path__ + "static/media/LinkedIn.830bb45b.svg";